import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { BiArrowFromLeft } from "react-icons/bi";
import { FiPower } from "react-icons/fi";
import { FaDownload } from "react-icons/fa";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "../landing-page.css";
import HousingService from "../Services/HousingService";
import { useHistory } from "react-router-dom";
import { TOKEN_INVALIDATE_URL } from "../Services/APIurls";
import { ClearLocalStorage, todayDate } from "../Components/utils/commonFunctions";
import Swal from "sweetalert2";
import { cloud_url_download, LOGIN_DOMAIN } from "../Services/Configuration";
import { AiOutlineHome } from "react-icons/ai";
import axiosTokenService from "../Services/axiosTokenService";
import moment from "moment-timezone";
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend, Sector, LabelList } from "recharts";

const Dashboardheader = () => {
  const user = localStorage.getItem("username");

  const isApshclUser = user === "APSHCL";
  const isDHUser = user.startsWith("DH");
  const isDMUser = user.startsWith("DM");
  const isGMF = user.startsWith("GMF1");
  const isManager = user.startsWith("MANAGER");
  const isCGGAdmin = user.startsWith("CGGADMIN");
  const isAdmin = user.startsWith("ADMIN");
  const isCFSSAdmin = user.startsWith("CFSSADMIN");
  const isGMAdmin = user.startsWith("GMADM");

  // if (
  //   localStorage.getItem("username") === "" ||
  //   localStorage.getItem("username") === undefined ||
  //   localStorage.getItem("username") === null
  // ) {
  //   Swal.fire({
  //     text: "Session Expired",
  //     icon: "error",
  //     confirmButtonText: "Ok",
  //     confirmButtonClass: "swal-button--confirm"
  //   }).then(function () {
  //     window.location = LOGIN_DOMAIN;
  //     window.location = LOGIN_DOMAIN;
  //   });
  // } else {
  // }
  
  const COLORS = ['#52b788', '#00b4d8', '#deab90', '#ffc60a', '#023e8a']; // Colors for the pie chart segments

  const history = useHistory();
  const [bankDetails, setBankDetails] = useState([]);
  const [showServices, setServices] = useState([]);
  const [showReports, setReports] = useState([]);
  const [showPayrollReports, setPayrollReports] = useState([]);
  // const [showBrsforms, setBrsForms] = useState([]);
  const [showAuditforms, setAuditForms] = useState([]);
  const [ShowManagerApprovals, setManagerApprovals] = useState([]);
  const [HousingReports, setHousingReports] = useState([]);
  const [GeneralServices, setGeneralServices] = useState([]);
  const [AdminServices, setAdminServices] = useState([]);
  const [isDashboard, setIsDashboard] = useState(true);
  const [graphData, setgraphData] = useState([]);
  const [countOfRegular, setCountOfRegular] = useState(0);
  const [countOfConsultant, setCountOfConsultant] = useState(0);
  const [countOfDeputation, setCountOfDeputation] = useState(0);
  const [countOfNMR, setCountOfNMR] = useState(0);
  const [countOfSpecialOfficers, setCountOfSpecialOfficers] = useState(0);
  const [countData, setCountData] = useState([]);
  // const [empStatusData, setempStatusData] = useState([]);



  useEffect(() => {
    console.log(localStorage.getItem("username"));
    if (localStorage.getItem("username") === "CFSSADMIN") {
      localStorage.setItem("prevUserId", localStorage.getItem("username"));
      localStorage.setItem("prevToken", localStorage.getItem("token"));
    }
    // HousingService.DashBoardBankDetails().then((res) => {
    //   setBankDetails(res.data);
    //   setIsDashboard(false);
    // });
    HousingService.getBankOpening_balanceDashboard().then((res) => {
      setBankDetails(res.data);
      setIsDashboard(false);
    });

    HousingService.getServices().then((res) => {
      if (res.data) {
        setServices(res.data.SDESC);
      }
    });

    HousingService.getReports().then((res) => {
      if (res.data) {
        setReports(res.data.SDESC);
      }
    });
    HousingService.getPayrollReports().then((res) => {
      if (res.data) {
        setPayrollReports(res.data.SDESC);
      }
    });

    // HousingService.BRSServices().then((res) => {
    //   if (res.data) {
    //     // setPayrollReports(res.data.SDESC);
    //     setBrsForms(res.data.SDESC);
    //   }
    // });
    HousingService.AuditServices().then((res) => {
      if (res.data) {
        // setPayrollReports(res.data.SDESC);
        setAuditForms(res.data.SDESC);
      }
    });

    // HousingService.getBRSForms().then((res) => {
    //   if (res.data) {
    //     setBrsForms(res.data.SDESC);
    //   }
    // });
    HousingService.getManagerApproveForms().then((res) => {
      if (res.data) {
        setManagerApprovals(res.data.SDESC);
      }
    });
    HousingService.getHousingReports().then((res) => {
      if (res.data) {
        setHousingReports(res.data.SDESC);
      }
    });
    HousingService.getGeneralServices().then((res) => {
      if (res.data) {
        setGeneralServices(res.data.SDESC);
      }
    });
    HousingService.getAdminServices().then((res) => {
      if (res.data) {
        setAdminServices(res.data.SDESC);
      }
    });
    HousingService.getDistWiseEmployeesData().then((res) => {
      if (res && res.data && res.data?.length > 0) {
        setCountData(res.data);
        const formattedData = res.data.map(item => ({
          district: item.district,
          count: item.total_employees,
        }));
        setgraphData(formattedData)
      }
    });

    HousingService.getEmployeeTypeData().then((res) => {
      if (res && res.data) {
        setCountOfRegular(res.data.empType1);
        setCountOfDeputation(res.data.empType2);
        setCountOfConsultant(res.data.empType3);
        setCountOfNMR(res.data.empType4);
        setCountOfSpecialOfficers(res.data.empType5);
      }
    });
    // HousingService.getDistWiseEmployeesData().then((res) => {
    //   if (res && res.data && res.data?.length > 0) {
    //     setCountData(res.data);
    //     const formattedData = res.data.map(item => ({
    //       district: item.district,
    //       count: item.total_employees,
    //     }));
    //     setgraphData(formattedData)
    //   }
    // });

    // HousingService.getEmployeeStatusData().then((res) => {
    //   if (res && res.data && res.data?.length > 0) {
    //     console.log(res.data)
    //     setempStatusData(res.data[0])
    //   }
    // });
  }, []);

  function handleLogOut() {
    Swal.fire({
      text: "Are You Sure Want to Logout?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes"
    }).then((result) => {
      if (result.isConfirmed) {
        axiosTokenService.post(TOKEN_INVALIDATE_URL).then((res) => {
          if (res !== "" && res !== undefined && res !== null) {
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            localStorage.removeItem("user");
            localStorage.clear();
            ClearLocalStorage();
            history.push("/logOut");
          }
        });
      }
    });
  }

  function handleChangePassword() {
    history.push("/ChangePassword.do");
  }

  const pieData = [
    { name: 'Regular', value: countOfRegular },
    { name: 'Deputation', value: countOfDeputation },
    { name: 'Consultant', value: countOfConsultant },
    { name: 'NMR', value: countOfNMR },
    { name: 'SpecialOfficers', value: countOfSpecialOfficers },
  ];



  return (
    <div className="Dashboard">
      <OFMSUI.Container fluid style={{ width: "100%" }}>
        <OFMSUI.Row>
          <OFMSUI.Navbar collapseOnSelect expand="lg" fixed="top" className="HERB-Top-Nav" style={{ posistion: "fixed", top: "0px" }} >
            <OFMSUI.Navbar.Brand href="Dashboardheader"> <img src="img/APSHCL.png" style={{ marginLeft: "5px" }} height="45" className="d-inline-block align-top" alt="APSHCL" /> </OFMSUI.Navbar.Brand>
            <OFMSUI.Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <OFMSUI.Navbar.Collapse id="responsive-navbar-nav">
              <OFMSUI.Nav className="me-auto"></OFMSUI.Nav>
              <OFMSUI.Nav> <a href="Dashboardheader"> <AiOutlineHome style={{ fontSize: "23px", marginRight: "10px", cursor: "pointer", color: "#212529" }} title="HOME" /> </a> </OFMSUI.Nav>
              <OFMSUI.Nav style={{ marginRight: "23px" }}> <OFMSUI.NavDropdown className="header-dropdown-setting" title={<b> <span> {"Welcome:"} {user} </span> &nbsp; </b>} id="basic-nav-dropdown" >
                <OFMSUI.NavDropdown.Item onClick={() => handleChangePassword()} > <a href="ChangePassword.do" style={{ color: "#212529" }}> <FiPower /> Change Password </a> </OFMSUI.NavDropdown.Item> 
                <OFMSUI.NavDropdown.Item onClick={() => handleLogOut()}> <FiPower onClick={() => handleLogOut()} /> LogOut </OFMSUI.NavDropdown.Item> </OFMSUI.NavDropdown>
              </OFMSUI.Nav> </OFMSUI.Navbar.Collapse>
          </OFMSUI.Navbar>
        </OFMSUI.Row>
      </OFMSUI.Container>

      <OFMSUI.Container fluid style={{ width: "95%" }}>
        <OFMSUI.Row>
          <OFMSUI.Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="page-titlespacing" >
            <div className="inner-herbpage-service-title1"> <h1 style={{ marginLeft: "-15px" }}>Dashboard</h1> </div>
          </OFMSUI.Col>
        </OFMSUI.Row>
      </OFMSUI.Container>

      <OFMSUI.Container fluid style={{ width: "95%" }}>
        <OFMSUI.Row>
          <Tabs>
            <TabList>
              <Tab> <img src="img/dashboard.png" className="tabiconc" alt="Dashboard" /> Dashboard </Tab>
              {!isDMUser && !isAdmin && !isCGGAdmin && !isCFSSAdmin && (<Tab> <img src="img/service.png" className="tabiconc" alt="Entry Forms" /> Entry Forms </Tab>)}
              {!isCGGAdmin && !isAdmin && !isCFSSAdmin && !isGMAdmin && (<Tab> <img src="img/report.png" className="tabiconc" alt="Reports" /> Reports </Tab>)}
              {!isDMUser && !isManager && !isCGGAdmin && !isAdmin && !isCFSSAdmin && (isApshclUser || isDHUser || isGMAdmin || isGMF) && (<Tab> <img src="img/payroll.jpg" className="tabiconc" alt="Dashboard" /> Payroll Reports </Tab>)}
              {/* {!isDMUser && !isManager && !isCGGAdmin && !isAdmin && !isCFSSAdmin && (isApshclUser || isDHUser || isGMAdmin || isGMF) && (<Tab> <img src="img/BRS.jpg" className="tabiconc" alt="Dashboard" /> BRS </Tab>)} */}
              {!isCGGAdmin && !isAdmin && !isCFSSAdmin && !isGMAdmin && (<Tab> <img src="img/report.png" className="tabiconc" alt="Reports" /> Audit Reports </Tab>)}

              {!isDHUser && !isDMUser && !isGMF && !isApshclUser && isManager && !isCGGAdmin && !isAdmin && !isCFSSAdmin && !isGMAdmin && (<Tab> <img src="img/approved.png" className="tabiconc" alt="Aprovals" /> APPROVALS </Tab>)}
              {!isDHUser && !isDMUser && !isGMF && !isApshclUser && !isManager && (isCFSSAdmin || isAdmin) && (<Tab> <img src="img/adminservices.png" className="tabiconc" alt="General Services" /> Admin Services </Tab>)}
              {!isDHUser && !isDMUser && !isGMF && !isApshclUser && !isManager && !isGMAdmin && (<Tab> <img src="img/generalservices.png" className="tabiconc" alt="General Services" /> General Services </Tab>)}
            </TabList>
            <TabPanel>
              {(user?.startsWith("DH") || user === "APSHCL") && (
                <>
                  <div className="text-center"> <h5> Bank Opening Balances of <span style={{ color: "#603913" }}  >{user} </span> as on {moment(todayDate).format("DD-MM-YYYY")} </h5> </div>
                  <OFMSUI.Table striped bordered hover id="my-table" fluid >
                    <thead className="fw-bold">
                      <tr className="table_countshead">
                        <th className="text-center">S No.</th> <th>Bank Name</th> <th>Branch Name</th> <th>IFSC Code</th> <th>Bank Name & A/C No.</th> <th className="text-center">Bank Balance</th> <th className="text-center">Passbook Copy</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bankDetails.map((bankDetail, index) => (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td> <td>{bankDetail.bankname}</td> <td>{bankDetail.branchname}</td> <td>{bankDetail.ifsc}</td> <td>{bankDetail.banknameaccountno}</td> <td className="text-right">{bankDetail.remaining_balance}</td>
                          <td style={{ fontSize: "21px", color: "green", textAlign: "center" }} >  <FaDownload onClick={() => window.open(cloud_url_download + 'apofms/Pay_Rec&file=' + bankDetail.passbook_path)} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </OFMSUI.Table>
                </>
              )}
              {user?.startsWith("GMADM") && (
                <div
                  style={{ display: "flex", justifyContent: "center", gap: "30px", flexWrap: "wrap", padding: 20 }}
                >
                  {/* Bar Chart */}
                  <div
                    style={{
                      flex: "1 1 600px",
                      maxWidth: "900px",
                      height: 500,
                      border: "1px solid #ddd",
                      padding: 10,
                      backgroundColor: "#f8f9fa",
                      borderRadius: 20,
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#18435a",
                        textShadow: "1px 1px 1px #ccc",
                      }}
                    >
                      <h5 style={{ margin: 0 }}> District Wise Employees </h5>
                      <img
                        src="img/district.png"
                        alt=""
                        style={{ marginLeft: "10px", width: "80px", height: "80px" }}
                      />
                    </div>
                    <ResponsiveContainer width="90%" height="90%">
                      <BarChart
                        data={graphData}
                        margin={{ top: 20, right: 30, left: 20, bottom: 100 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                          dataKey="district"
                          tick={{ fontSize: 12, fill: "#1b263b" }}
                          angle={45}
                          textAnchor="start"
                          interval={0}
                          height={60}
                          stroke="#16324f"
                          style={{
                            fontWeight: "bold",
                            textShadow: "1px 1px 2px #ccc",
                          }}
                        />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="count" fill="#abc4ff" radius={[10, 10, 0, 0]}>
                          <LabelList
                            dataKey="count"
                            position="top"
                            fill="#3c63cd"
                            style={{
                              fontSize: 12,
                              fontWeight: "bold",
                              textShadow: "1px 1px 2px #ccc",
                            }}
                          />
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </div>

                  {/* Donut Chart */}
                  <div
                    style={{
                      flex: "1 1 400px",
                      maxWidth: "450px",
                      height: 500,
                      border: "1px solid #ddd",
                      padding: 10,
                      backgroundColor: "#f5fefc",
                      borderRadius: 20,
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                    }}
                  >
                    <h5
                      style={{
                        textAlign: "center",
                        color: "#34a0a4",
                        textShadow: "1px 1px 1px #ccc",
                      }}
                    >
                      Employee Type Distribution
                    </h5>
                    <img
                      src="img/staff.png"
                      alt="employee"
                      style={{
                        display: "block",
                        margin: "10px auto",
                        width: "80px",
                        height: "80px",
                      }}
                    />
                    <ResponsiveContainer width="100%" height="60%">
                      <PieChart>
                        <Pie
                          data={pieData}
                          cx="50%"
                          cy="50%"
                          innerRadius={60}
                          outerRadius={100}
                          label
                        >
                          {pieData.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                            />
                          ))}
                        </Pie>
                        <Tooltip />
                        <Legend />
                      </PieChart>
                    </ResponsiveContainer>
                    <p
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        color: "#2a9d8f",
                        marginTop: 10,
                      }}
                    >
                      TOTAL : {pieData.reduce((sum, item) => sum + item.value, 0)}
                    </p>
                  </div>

                  {/* Employee Status Count (Static) */}
                  {/* <div
                    style={{
                      flex: "1 1 300px",
                      maxWidth: "300px",
                      height: 500,
                      border: "1px solid #ddd",
                      padding: 20,
                      backgroundColor: "white",
                      borderRadius: 20,
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <h5
                      style={{
                        textAlign: "start",
                        color: "#00b4d8",
                        textShadow: "1px 1px 1px #ccc",
                      }}
                    >
                      Employee Status Count
                    </h5>

                    <img
                      src="img/search.png"
                      alt="employee"
                      style={{
                        display: "block",
                        margin: "10px auto",
                        width: "80px",
                        height: "80px",
                      }}
                    />

                    <div style={{ fontSize: "1.1rem", marginTop: 10 }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <div style={{ display: "flex", alignItems: "center", border: "1px solid #eee", padding: 10, borderRadius: 10, backgroundColor: "#effbf9" }}>
                          <img src="img/number-1.png" alt="1" style={{ width: 24, height: 24, marginRight: 8 }} />
                          Working:&nbsp;{empStatusData?.working}
                        </div>
                        <div style={{ display: "flex", alignItems: "center", border: "1px solid #eee", padding: 10, borderRadius: 10, backgroundColor: "#effbf9" }}>
                          <img src="img/two.png" alt="2" style={{ width: 24, height: 24, marginRight: 8 }} />
                          Suspended:&nbsp;{empStatusData?.suspended}
                        </div>
                      </div>
                    </div>

                  </div> */}

                </div>
              )}


            </TabPanel>

            {!isDMUser && !isAdmin && !isCGGAdmin && !isCFSSAdmin && (
              <TabPanel>
                <OFMSUI.Container fluid style={{ width: "100%" }}>
                  {showServices != "Details Not Found" &&
                    showServices.map((rowdata, i) => {
                      return (
                        <>
                          <OFMSUI.Row style={{ paddingBottom: "50px" }}>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} > <div className="inner-herbpage-service-title2"> <h1>{rowdata.service_id[0].service_name}</h1> </div> </OFMSUI.Col>
                            {rowdata.inner.map((services, index) => {
                              return (
                                <>
                                  <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} >
                                    <div className="cards card1 bg-white mb-4">
                                      <div className="cards-body">
                                        <a href={services.target}>
                                          <div className="go-corner"> <div className="go-arrow"> <BiArrowFromLeft className="cardico icon-size-header2" /> </div> </div>
                                          <h5 > {services.service_name} </h5>
                                        </a>
                                      </div>
                                    </div>
                                  </OFMSUI.Col>
                                </>
                              );
                            })}
                          </OFMSUI.Row>
                        </>
                      );
                    })}
                </OFMSUI.Container>
              </TabPanel>
            )}
            {/* Reports */}
            {!isCGGAdmin && !isAdmin && !isCFSSAdmin && !isGMAdmin && (
              <TabPanel>
                <OFMSUI.Container fluid style={{ width: "100%" }}>
                  {showReports != "Details Not Found" && showReports.map((rowdata, i) => {
                    return (
                      <>
                        <OFMSUI.Row style={{ paddingBottom: "50px" }}>
                          <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} >
                            <div className="inner-herbpage-service-title2"> <h1>{rowdata.service_id[0].service_name}</h1> </div>
                          </OFMSUI.Col>
                          {rowdata.inner.map((services, index) => {
                            return (
                              <>
                                <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} >
                                  <div className="cards card1 bg-white mb-4">
                                    <div className="cards-body">
                                      <a href={services.target}>
                                        <div className="go-corner"> <div className="go-arrow"> <BiArrowFromLeft className="cardico icon-size-header2" /> </div> </div>
                                        <h5 className="cards_title float-start"> {services.service_name} </h5>
                                      </a>
                                    </div>
                                  </div>
                                </OFMSUI.Col>
                              </>
                            );
                          })}
                        </OFMSUI.Row>
                      </>
                    );
                  })}
                </OFMSUI.Container>
              </TabPanel>
            )}
            {/* PayrollReports */}
            {!isDMUser &&
              !isManager &&
              !isCGGAdmin &&
              !isAdmin &&
              !isCFSSAdmin &&
              (isDHUser || isApshclUser || isGMAdmin || isGMF) && (
                <TabPanel>
                  <OFMSUI.Container fluid style={{ width: "100%" }}>
                    {showPayrollReports != "Details Not Found" &&
                      showPayrollReports.map((rowdata, i) => {
                        return (
                          <>
                            <OFMSUI.Row style={{ paddingBottom: "50px" }}>
                              <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} >
                                <div className="inner-herbpage-service-title2"> <h1>{rowdata.service_id[0].service_name}</h1> </div>
                              </OFMSUI.Col>
                              {rowdata.inner.map((services, index) => {
                                return (
                                  <>
                                    <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} >
                                      <div className="cards card1 bg-white mb-4">
                                        <div className="cards-body">
                                          <a href={services.target}>
                                            <div className="go-corner">
                                              <div className="go-arrow"> <BiArrowFromLeft className="cardico icon-size-header2" /> </div>
                                            </div>
                                            <h5 className="cards_title float-start"> {services.service_name} </h5>
                                          </a>
                                        </div>
                                      </div>
                                    </OFMSUI.Col>
                                  </>
                                );
                              })}
                            </OFMSUI.Row>
                          </>
                        );
                      })}
                  </OFMSUI.Container>
                </TabPanel>
              )}
            {/* BRS */}
            {/* {!isDMUser &&
              !isManager &&
              !isCGGAdmin &&
              !isAdmin &&
              !isCFSSAdmin &&
              (isDHUser || isApshclUser || isGMAdmin || isGMF) && (
                <TabPanel>
                  <OFMSUI.Container fluid style={{ width: "100%" }}>
                    {showBrsforms != "Details Not Found" &&
                      showBrsforms.map((rowdata, i) => {
                        return (
                          <>
                            <OFMSUI.Row style={{ paddingBottom: "50px" }}>
                              <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} >
                                <div className="inner-herbpage-service-title2"> <h1>{rowdata.service_id[0].service_name}</h1> </div>
                              </OFMSUI.Col>
                              {rowdata.inner.map((services, index) => {
                                return (
                                  <>
                                    <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} >
                                      <div className="cards card1 bg-white mb-4">
                                        <div className="cards-body">
                                          <a href={services.target}>
                                            <div className="go-corner">
                                              <div className="go-arrow"> <BiArrowFromLeft className="cardico icon-size-header2" /> </div>
                                            </div>
                                            <h5 className="cards_title float-start"> {services.service_name} </h5>
                                          </a>
                                        </div>
                                      </div>
                                    </OFMSUI.Col>
                                  </>
                                );
                              })}
                            </OFMSUI.Row>
                          </>
                        );
                      })}
                  </OFMSUI.Container>
                </TabPanel>
              )} */}
            {!isDMUser &&
              !isManager &&
              !isCGGAdmin &&
              !isAdmin &&
              !isCFSSAdmin &&
              (isDHUser || isApshclUser || isGMAdmin || isGMF) && (
                <TabPanel>
                  <OFMSUI.Container fluid style={{ width: "100%" }}>
                    {showAuditforms != "Details Not Found" &&
                      showAuditforms.map((rowdata, i) => {
                        return (
                          <>
                            <OFMSUI.Row style={{ paddingBottom: "50px" }}>
                              <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} >
                                <div className="inner-herbpage-service-title2"> <h1>{rowdata.service_id[0].service_name}</h1> </div>
                              </OFMSUI.Col>
                              {rowdata.inner.map((services, index) => {
                                return (
                                  <>
                                    <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} >
                                      <div className="cards card1 bg-white mb-4">
                                        <div className="cards-body">
                                          <a href={services.target}>
                                            <div className="go-corner">
                                              <div className="go-arrow"> <BiArrowFromLeft className="cardico icon-size-header2" /> </div>
                                            </div>
                                            <h5 className="cards_title float-start"> {services.service_name} </h5>
                                          </a>
                                        </div>
                                      </div>
                                    </OFMSUI.Col>
                                  </>
                                );
                              })}
                            </OFMSUI.Row>
                          </>
                        );
                      })}
                  </OFMSUI.Container>
                </TabPanel>
              )}

            {!isDHUser && !isDMUser && !isGMF && !isApshclUser && isManager && (
              <TabPanel>

                <OFMSUI.Container fluid style={{ width: "100%" }}>
                  {ShowManagerApprovals != "Details Not Found" &&
                    ShowManagerApprovals.map((rowdata, i) => {
                      return (
                        <>
                          <OFMSUI.Row style={{ paddingBottom: "50px" }}>
                            <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} >
                              <div className="inner-herbpage-service-title2"> <h1>{rowdata.service_id[0].service_name}</h1> </div>
                            </OFMSUI.Col>
                            {rowdata.inner.map((approvals, index) => {
                              return (
                                <>
                                  <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} >
                                    <div className="cards card1 bg-white mb-4">
                                      <div className="cards-body">
                                        <a href={approvals.target}>
                                          <div className="go-corner">
                                            <div className="go-arrow"> <BiArrowFromLeft className="cardico icon-size-header2" /> </div> </div>
                                          <h5 className="cards_title float-start"> {approvals.service_name} </h5>
                                        </a>
                                      </div>
                                    </div>
                                  </OFMSUI.Col>
                                </>
                              );
                            })}
                          </OFMSUI.Row>
                        </>
                      );
                    })}
                </OFMSUI.Container>
              </TabPanel>
            )}
            {/* Admin services */}
            {!isDHUser &&
              !isDMUser &&
              !isGMF &&
              !isApshclUser &&
              !isManager &&
              (isCFSSAdmin || isAdmin) && (
                <TabPanel>
                  <OFMSUI.Container fluid style={{ width: "100%" }}>
                    {AdminServices != "Details Not Found" &&
                      AdminServices.map((rowdata, i) => {
                        return (
                          <>
                            <OFMSUI.Row style={{ paddingBottom: "50px" }}>
                              <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} >
                                <div className="inner-herbpage-service-title2">
                                  <h1>Admin Services</h1>
                                </div>
                              </OFMSUI.Col>
                              {rowdata.service_id.map(
                                (adminservices, index) => {
                                  return (
                                    <>
                                      <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} >
                                        <div className="cards card1 bg-white mb-4">
                                          <div className="cards-body">
                                            <a href={adminservices.target}>
                                              <div className="go-corner"> <div className="go-arrow"> <BiArrowFromLeft className="cardico icon-size-header2" /> </div> </div>
                                              <h5 className="cards_title float-start">
                                                {adminservices.service_name.substring(
                                                  adminservices.service_name.indexOf(
                                                    "::"
                                                  ) + 2
                                                )}
                                              </h5>
                                            </a>
                                          </div>
                                        </div>
                                      </OFMSUI.Col>
                                    </>
                                  );
                                }
                              )}
                            </OFMSUI.Row>
                          </>
                        );
                      })}
                  </OFMSUI.Container>
                </TabPanel>
              )}
            {/* general services  */}
            {!isDHUser &&
              !isDMUser &&
              !isGMF &&
              !isApshclUser &&
              !isManager &&
              !isGMAdmin && (
                <TabPanel>
                  <OFMSUI.Container fluid style={{ width: "100%" }}>
                    {GeneralServices != "Details Not Found" &&
                      GeneralServices.map((rowdata, i) => {
                        return (
                          <>
                            <OFMSUI.Row style={{ paddingBottom: "50px" }}>
                              <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} >
                                <div className="inner-herbpage-service-title2">
                                  <h1>General Services</h1>
                                </div>
                              </OFMSUI.Col>
                              {rowdata.service_id.map(
                                (generalservices, index) => {
                                  return (
                                    <>
                                      <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} >
                                        <div className="cards card1 bg-white mb-4">
                                          <div className="cards-body">
                                            <a href={generalservices.target}>
                                              <div className="go-corner">

                                                <div className="go-arrow">

                                                  <BiArrowFromLeft className="cardico icon-size-header2" />
                                                </div>
                                              </div>
                                              <h5 className="cards_title float-start">
                                                {generalservices.service_name.substring(
                                                  generalservices.service_name.indexOf(
                                                    "::"
                                                  ) + 2
                                                )}
                                              </h5>
                                            </a>
                                          </div>
                                        </div>
                                      </OFMSUI.Col>
                                    </>
                                  );
                                }
                              )}
                            </OFMSUI.Row>
                          </>
                        );
                      })}
                  </OFMSUI.Container>
                </TabPanel>
              )}
            {/* BRS */}

          </Tabs>
        </OFMSUI.Row>
      </OFMSUI.Container>
    </div>
  );
};
export default Dashboardheader;
